import React from "react";

// Animated aurora waves background using the UAICARD brand palette.
// Layered SVG waves drift horizontally over a deep-navy gradient.
const AnimatedWaves = ({ className = "" }) => {
  return (
    <div className={`aurora-bg ${className}`} aria-hidden="true">
      <div className="aurora-glow aurora-glow-1" />
      <div className="aurora-glow aurora-glow-2" />
      <div className="aurora-grain" />
      <svg
        className="aurora-waves"
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="waveA" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#2E6BFF" stopOpacity="0.55" />
            <stop offset="100%" stopColor="#3B4FE0" stopOpacity="0.35" />
          </linearGradient>
          <linearGradient id="waveB" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#1B3FB8" stopOpacity="0.45" />
            <stop offset="100%" stopColor="#2E6BFF" stopOpacity="0.25" />
          </linearGradient>
        </defs>
        <g className="wave wave-1">
          <path
            fill="url(#waveA)"
            d="M0,160 C240,80 480,240 720,180 C960,120 1200,220 1440,150 L1440,320 L0,320 Z"
          />
          <path
            fill="url(#waveA)"
            transform="translate(1440,0)"
            d="M0,160 C240,80 480,240 720,180 C960,120 1200,220 1440,150 L1440,320 L0,320 Z"
          />
        </g>
        <g className="wave wave-2">
          <path
            fill="url(#waveB)"
            d="M0,220 C300,150 520,280 780,220 C1040,160 1200,260 1440,210 L1440,320 L0,320 Z"
          />
          <path
            fill="url(#waveB)"
            transform="translate(1440,0)"
            d="M0,220 C300,150 520,280 780,220 C1040,160 1200,260 1440,210 L1440,320 L0,320 Z"
          />
        </g>
      </svg>
    </div>
  );
};

export default AnimatedWaves;
